import { useState } from "react"
import { Frozen, logo, NotActived, Overdue, Ready, unView, view } from "../assets/images/images"
import CheckInput from "../assets/images/CheckInput"
import { useNavigate } from "react-router-dom";
import { validateEmail } from "../share/validation";
import { signin } from "../services/api/auth.service";
import { publish } from "../services/loadingServices/loading.service";
import { menuSidebarTest } from "../component/SidebarCore";
import CheckIconWhite from "../assets/images/CheckIconWhite";
import PopupStatusCompany from "../component/PopupStatusCompany";

const Signin = () => {
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const [isChecked, setIsChecked] = useState(false);
    const nav = useNavigate();
    const [formValues, setFormValues] = useState({
        email: "",
        password: "",
        keepLogin: false,
    });
    const [errors, setErrors] = useState({
        email: '',
        password: '',
    });
    const [showInformation, setShowInformation] = useState<any>({
        name: null,
        description: null,
        title: null,
        image: null,
        isActive: false
    });
    const [apiError, setApiError] = useState<string>('');

    const getRedirectPath = (moduleData: { group: string; name: string }): string => {
        const { group, name } = moduleData;
        for (const menu of menuSidebarTest) {
            if (menu.title === group && menu.children) {
                const child = menu.children.find(c => c.title === name);
                if (child) return child.path;
            }
            if (menu.title === name && menu.path) {
                return menu.path;
            }
        }
        return '/dashboard';
    };
    const getStatus = (type: string) => {
        const listStatus = [
            {
                id: 1,
                name: 'frozen',
                description: 'Your account has been frozen and login is currently disabled. To regain access, please contact our support team.',
                title: 'Your account is frozen',
                image: <img src={Frozen} className="w-full h-full object-cover" />
            },
            {
                id: 2,
                name: 'registered',
                description: 'Your company has been successfully registered. Before you can access the dashboard, we need a moment to verify your information for security and billing purposes.',
                title: 'Welcome! 🎉 We’re reviewing your account',
                subTitle: 'We’ll notify you by email once everything is ready.',
                image: <img src={Ready} className="w-full h-full object-cover" />
            },
            {
                id: 3,
                name: 'payment overdue',
                description: 'Your payment is overdue, and access to your account has been temporarily restricted. Please complete your payment to restore full access, or contact our support team if you need assistance.',
                title: 'Payment overdue',
                image: <img src={Overdue} className="w-full h-full object-cover" />
            },
            {
                id: 4,
                name: 'NotActived',
                description: 'Your account is currently inactive. Please contact support for help.',
                title: 'Account not activated',
                image: <img src={NotActived} className="w-full h-full object-cover" />
            },
        ]
        return listStatus.find((v) => v.name === type);
    }

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
        const { name, value } = e.target;
        const newValue = name === "email" ? value.trim().toLowerCase() : value.trim();
        setFormValues(prev => ({ ...prev, [name]: newValue }));
        if (name === 'email') {
            if (!newValue) {
                setErrors(prev => ({ ...prev, email: 'Email is required' }));
            } else if (!validateEmail(newValue)) {
                setErrors(prev => ({ ...prev, email: 'Please enter a valid email address' }));
            } else {
                setErrors(prev => ({ ...prev, email: '' }));
            }
        }
    };
    const getDeviceInfo = () => {
        const deviceType = /Mobi|Android/i.test(navigator.userAgent) ? 'Mobile' : 'Desktop';
        const operatingSystem = (() => {
            const userAgent = navigator.userAgent;
            if (userAgent.indexOf('Win') !== -1) return 'Windows';
            if (userAgent.indexOf('Mac') !== -1) return 'MacOS';
            if (userAgent.indexOf('X11') !== -1 || userAgent.indexOf('Linux') !== -1) return 'Linux';
            return 'Unknown OS';
        })();
        const browserInfo = (() => {
            const userAgent = navigator.userAgent;
            if (userAgent.indexOf('Chrome') !== -1) return 'Chrome';
            if (userAgent.indexOf('Firefox') !== -1) return 'Firefox';
            if (userAgent.indexOf('Safari') !== -1) return 'Safari';
            return 'Unknown Browser';
        })();
        const userAgent = navigator.userAgent;

        return { deviceType, operatingSystem, browserInfo, userAgent };
    };
    const isFormLogin = () => {
        const { email, password } = formValues;
        return validateEmail(email) && password && !errors.email && !errors.password;
    };

    const handleSubmitSignin = async (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        setApiError('');
        // setShowInformation({ ...getStatus("Ready"), isActive: true });
        publish('loading', true);
        try {
            const payload = {
                email: formValues.email.trim().toLowerCase(),
                password: formValues?.password,
                ...getDeviceInfo()
            }
            const response = await signin(payload);
            console.log("🚀 ~ handleSubmitSignin ~ response:", response)
            if (response.data.success) {
                localStorage.setItem("accessToken", response?.data?.tokens?.accessToken);
                localStorage.setItem("refreshToken", response?.data?.tokens?.refreshToken);
                localStorage.setItem("userId", response?.data?.user?.id);
                localStorage.setItem("companyId", response?.data?.user?.companyId);
                localStorage.setItem("language", (response?.data?.user?.defaultLanguageCode || '').toLowerCase() || 'en');
                localStorage.setItem("sessionId", response?.data?.sessionId);
                publish('loading', false);

                const lang = localStorage.getItem("language") || "en";
                const defaultModule = response?.data?.loadModule;
                if (defaultModule) {
                    const redirectPath = getRedirectPath({ group: defaultModule.group, name: defaultModule.name });
                    window.location.href = `/${lang}${redirectPath}`;
                } else {
                    window.location.href = `/${lang}/dashboard`;
                }
            } else {
                setApiError(response.data.message);
                publish('loading', false);
            }
        } catch (error: any) {
            publish('loading', false);
            if (getStatus(error.response?.data?.message)) {
                const statusInfo = getStatus(error.response?.data?.message);
                console.log("🚀 ~ handleSubmitSignin ~ statusInfo:", statusInfo)
                setShowInformation({ ...statusInfo, isActive: true });
                return;
            }
            setApiError(error.response?.data?.message || 'An error occurred during signin');
            console.error(' failed:', error);
        }
    }
    return (
        <>
            <div className="py-16 h-full flex flex-col justify-between">
                <img src={logo} className="w-fit " />
                <div className="space-y-10">
                    <p className="text-[32px] text-[#05292A] font-semibold font-inter">Log in</p>
                    <form className="w-full space-y-8 max-w-[550px]" onSubmit={(e: any) => handleSubmitSignin(e)}>
                        <div className="space-y-4">
                            <div className="space-y-8">
                                <div className="w-full space-y-2">
                                    <p className="text-[14px] text-main font-medium font-inter no-select">Email address</p>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formValues.email}
                                        onChange={handleChange}
                                        autoCapitalize="none"
                                        autoCorrect="off"
                                        spellCheck={false}
                                        autoComplete="email"
                                        required
                                        className={`text-[14px] placeholder:text-subtitle text-subtitle font-medium border px-4 py-[14px]  rounded-xl outline-none focus-none bg-transparent w-full ${errors?.email.length ? "border-[#E40F03]" : "border-[#EBEBED]"} `}
                                    />
                                    {errors?.email.length > 0 && <p className="text-base font-medium text-[#E40F03] ">{errors?.email}</p>}
                                </div>
                                <div className="w-full space-y-2">
                                    <p className="text-[14px] text-main font-medium font-inter no-select">Password</p>
                                    <div className="relative">
                                        <input
                                            name="password"
                                            value={formValues.password}
                                            onChange={handleChange}
                                            required
                                            type={showPassword ? "text" : "password"}
                                            className={`text-[14px] placeholder:text-subtitle text-subtitle font-medium border  px-4 py-[14px]  rounded-xl outline-none focus-none bg-transparent w-full ${errors?.password.length ? "border-[#E40F03]" : "border-[#EBEBED]"} `}
                                        />
                                        <div className="absolute top-1/2 -translate-y-1/2 right-4">
                                            <img src={!showPassword ? view : unView} className="w-6 aspect-square cursor-pointer" onClick={() => { setShowPassword(!showPassword) }} />
                                        </div>
                                    </div>
                                    {errors?.password.length > 0 && <p className="text-base font-medium text-[#E40F03] ">{errors?.password}</p>}
                                </div>
                            </div>
                            <div className="w-full flex items-center justify-between">
                                <div className="flex items-center gap-x-2 cursor-pointer" onClick={() => { setIsChecked(!isChecked); setFormValues(prev => ({ ...prev, keepLogin: !isChecked })); }}>
                                    <div className="flex items-center gap-x-2"
                                        style={{
                                            width: '20px',
                                            height: '20px',
                                            borderRadius: '6px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            transition: 'all 0.2s',
                                            backgroundColor: isChecked ? '#0F7679' : 'white',
                                            border: isChecked ? 'none' : '2px solid #d1d5db',
                                            color: 'white'
                                        }}
                                    >
                                        {isChecked && <CheckIconWhite />}
                                    </div>
                                    <p className="text-sm font-medium text-[#4A5353] font-inter" >Keep me logged in</p>
                                </div>
                                <p className="text-sm font-inter font-medium text-[#0F7679] cursor-pointer no-select" onClick={() => { nav("/resetPassword") }}>Forgot Password?</p>
                            </div>
                        </div>
                        <button type="submit" disabled={!isFormLogin()} className={`w-full h-10 text-sm font-medium flex items-center justify-center rounded-[30px] ${isFormLogin() ? "bg-[#0F7679] text-white" : "bg-[#F8F8F8] text-[#C9D7D8]"}`}>
                            Sign In
                        </button>
                        {apiError && (
                            <p className="text-red-500 text-sm mt-4 text-center">{apiError}</p>
                        )}
                    </form>
                </div>
                <div className="flex items-center gap-x-1 font-medium">
                    <p className="text-[#4A5353] text-sm">Don’t have an account?  </p>
                    <p className="cursor-pointer text-[#0F7679] text-sm" onClick={() => { nav("/signup") }}>Sign up</p>
                </div>
            </div>
            <PopupStatusCompany
                title={showInformation?.title}
                subTitle={showInformation?.subTitle}
                description={showInformation?.description}
                image={showInformation?.image}
                isActive={showInformation?.isActive}
                onClose={() => { setShowInformation({ ...showInformation, isActive: false }) }}
            />
        </>
    )
}
export default Signin